var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpreadsheetToasterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_139771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.5C2 1.96957 2.21071 1.46086 2.58579 1.08579C2.96086 0.710714 3.46957 0.5 4 0.5H12C12.5304 0.5 13.0391 0.710714 13.4142 1.08579C13.7893 1.46086 14 1.96957 14 2.5V14.5C14 15.0304 13.7893 15.5391 13.4142 15.9142C13.0391 16.2893 12.5304 16.5 12 16.5H4C3.46957 16.5 2.96086 16.2893 2.58579 15.9142C2.21071 15.5391 2 15.0304 2 14.5V2.5ZM4 1.5C3.73478 1.5 3.48043 1.60536 3.29289 1.79289C3.10536 1.98043 3 2.23478 3 2.5V6.5H13V2.5C13 2.23478 12.8946 1.98043 12.7071 1.79289C12.5196 1.60536 12.2652 1.5 12 1.5H4ZM13 7.5H10V9.5H13V7.5ZM13 10.5H10V12.5H13V10.5ZM13 13.5H10V15.5H12C12.2652 15.5 12.5196 15.3946 12.7071 15.2071C12.8946 15.0196 13 14.7652 13 14.5V13.5ZM9 15.5V13.5H6V15.5H9ZM5 15.5V13.5H3V14.5C3 14.7652 3.10536 15.0196 3.29289 15.2071C3.48043 15.3946 3.73478 15.5 4 15.5H5ZM3 12.5H5V10.5H3V12.5ZM3 9.5H5V7.5H3V9.5ZM6 7.5V9.5H9V7.5H6ZM9 10.5H6V12.5H9V10.5Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_139771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheetToasterIcon);
export default __webpack_public_path__ + "static/media/spreadsheetToasterIcon.eb0c06973037c54e345244b3e0532664.svg";
export { ForwardRef as ReactComponent };